<template>
    <div>
        <Main title="My POIs" subtitle="Company Point Of Interests">
            <template v-slot:table>
                <v-app>
                    <div class="row mb-1 justify-content-between">
                        <div class="col-md-4 align-self-center">
                            <div class="input-group">
                                <v-text-field
                                    v-model="searchData.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by ID, Address, City, State, ZIP, DMAs and External IDs"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-md-3 align-self-center">
                            <div class="row">
                                <div class="col-6 text-center mb-6">
                                    <v-skeleton-loader
                                        :loading="$store.getters.getTierLoadingStatus"
                                        transition="fade-transition"
                                        height="94"
                                        type="list-item-two-line"
                                    >
                                        <v-tooltip color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <span class="info-label d-block mb-1 font-lg">Total Locations</span>
                                                    <span class="info-data p-2">{{ new Intl.NumberFormat().format($store.getters.getCompanyTierStatus.pois) }} / {{ new Intl.NumberFormat().format($store.getters.getCompanyTier.pois) }}</span>
                                                </div>
                                            </template>
                                            <span>Total POIs available for your company.</span>
                                        </v-tooltip>
                                    </v-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 align-self-center">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button v-if="exportRoute" class="btn btn-light mr-1 export-to-csv" @click="exportData" type="button" id="export-to-csv" formtarget="_blank" data-toggle="tooltip" data-placement="top" title="" data-original-title="Export data as .csv">
                                    <i class="fas fa-file-excel"></i>
                                </button>
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">POIs - Sort and Filter</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            md="6"
                                        >
                                            <template>
                                                <v-container fluid>
                                                    <v-select
                                                        v-model="brands"
                                                        :items="all_brands"
                                                        label="Brand"
                                                        clearable
                                                    >
                                                        <template v-slot:selection="{ item, index }">
                                                            <v-chip small v-if="index === 0">
                                                                <span>{{ item.text }}</span>
                                                            </v-chip>
                                                        </template>

                                                        <template v-slot:prepend-item>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-text-field v-model="search_brands" placeholder="Search" @input="search('brands')"></v-text-field>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-select>
                                                </v-container>
                                            </template>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                        >
                                            <template>
                                                <v-container fluid>
                                                    <v-select
                                                        v-model="countries"
                                                        :items="all_countries"
                                                        label="Country"
                                                        clearable
                                                    >
                                                        <template v-slot:selection="{ item, index }">
                                                            <v-chip small v-if="index === 0">
                                                                <span>{{ item.text }}</span>
                                                            </v-chip>
                                                        </template>

                                                        <template v-slot:prepend-item>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-text-field v-model="search_countries" placeholder="Search" @input="search('countries')"></v-text-field>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-select>
                                                </v-container>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.perPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.type"
                                                :items="types"
                                                label="Type"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="searchData.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TableLoading cols="14" v-if="loading"></TableLoading>
                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Location ID</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Store ID</span>
                                        </template>
                                        <span>Store Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Name</span>
                                        </template>
                                        <span>POI Name</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Address</span>
                                        </template>
                                        <span>Address 1</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">City</span>
                                        </template>
                                        <span>POI City</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">State</span>
                                        </template>
                                        <span>POI State</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ZIP</span>
                                        </template>
                                        <span>POI ZIP Code</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">DMA Desc</span>
                                        </template>
                                        <span>DMA Description</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Country</span>
                                        </template>
                                        <span>POI Alpha-3 Country Code</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Lon & Lat</span>
                                        </template>
                                        <span>POI Longitude & Latitude</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Polygon</span>
                                        </template>
                                        <span>POI Polygon</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Sqft</span>
                                        </template>
                                        <span>Location Total Square Feet</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">External ID</span>
                                        </template>
                                        <span>POI External ID</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Brand</span>
                                        </template>
                                        <span>POI Brand Name</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>POI Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th class="align-top">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>POI Created at</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="location in locations" :key="location.id" class="locations-row">
                                <td>{{ location.id || '' }}</td>
                                <td>{{ location.store_id || '' }}</td>
                                <td>{{ location.name || '' }}</td>
                                <td>{{ location.address1 || '' }}</td>
                                <td>{{ location.city || '' }}</td>
                                <td>{{ location.state || '' }}</td>
                                <td>{{ location.zip_code || '' }}</td>
                                <td>{{ location.dma_desc || '' }}</td>
                                <td>{{ location.country || '' }}</td>
                                <td>{{ location.lon + ', ' + location.lat }}</td>
                                <td class="text-center">
                                    <v-tooltip left max-width="250" v-if="location.polygon">
                                        <template v-slot:activator="{ on, attrs }">
                                            <i
                                                v-bind="attrs"
                                                v-on="on"
                                                class="fas fa-check-circle text-success"
                                            ></i>
                                        </template>
                                        <span>{{ location.polygon.coordinates.join() }}</span>
                                    </v-tooltip>
                                </td>
                                <td>{{ location.sqft || '' }}</td>
                                <td>{{ location.external_id || '' }}</td>
                                <td>
                                    <span v-if="location.brand">{{ location.brand.name || '' }}</span>
                                </td>
                                <td>{{ location.updated_at || '' }}</td>
                                <td>{{ location.created_at || '' }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <v-pagination
                            color="#ff7516"
                            v-if="totalPages > 1"
                            v-model="currentPage"
                            :length="totalPages"
                            :total-visible="7"
                        ></v-pagination>
                    </div>
                </v-app>
            </template>
        </Main>
    </div>
</template>

<script>
import Main from '../../../components/Main'
import api from "../../../api/my-data/poi/submissions";
import mixins from "../../../mixin";
import TableLoading from "../../../components/general/TableLoading";

export default {
    name: "MyPois",
    mixins: [mixins],
    data: () => ({
        filter: false,

        all_brands: [],
        all_brands_copy: [],
        brands: '',
        search_brands: '',

        all_countries: [],
        all_countries_copy: [],
        countries: '',
        search_countries: '',

        searchData: {
            q: '',
            type: 0,
            sortBy: 'updated_at',
            orderBy: 'desc',
            perPage: 25,
            loading: false,
        },
        currentPage: 1,
        totalPages: 1,

        sorts: [
            {
                value: 'id',
                text: 'ID'
            },
            {
                value: 'store_id',
                text: 'Store ID'
            },
            {
                value: 'address1',
                text: 'Address 1'
            },
            {
                value: 'address2',
                text: 'Address 2'
            },
            {
                value: 'city',
                text: 'City'
            },
            {
                value: 'state',
                text: 'State'
            },
            {
                value: 'zip_code',
                text: 'Zip Code'
            },
            {
                value: 'country',
                text: 'Country'
            },
            {
                value: 'external_id',
                text: 'External ID'
            },
            {
                value: 'lon',
                text: 'Longitude'
            },
            {
                value: 'lat',
                text: 'Latitude'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],

        types: [
            {
                value: 0,
                text: 'All'
            },
            {
                value: 1,
                text: 'Polygons'
            },
            {
                value: 2,
                text: 'Centroids'
            },
        ],

        loading: true,
        deleteModalDialog: false,
        locations: [],
        location: [],
        deletingLocation: [],

        exportRoute: '',
    }),
    components: {
        TableLoading,
        Main,
    },
    methods: {
        async fetchData() {
            await api.getAllCompanyLocations({
                page: this.currentPage,
                q: this.searchData.q,
                brand: this.brands,
                country: this.countries,
                sortBy: this.searchData.sortBy,
                orderBy: this.searchData.orderBy,
                perPage: this.searchData.perPage,
                type: this.searchData.type,
            })
            .then(res => {
                this.locations = res.data.data.data
                this.loading = false
                this.currentPage = res.data.data.current_page
                this.totalPages = res.data.data.last_page
                this.exportRoute = res.data.export
                this.scrollToTop()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.redirectToMyPoisPage()
            })
        },
        async fetchBrands() {
            await api.getAllBrands()
                .then(res => {
                    this.all_brands = res.data
                    this.all_brands_copy = res.data
                })
        },
        async fetchCountries() {
            await api.getAllCountries()
                .then(res => {
                    this.all_countries = res.data
                    this.all_countries_copy = res.data
                })
        },
        redirectToMyPoisPage: _.debounce(function() {
            window.location.href = this.my_pois_url
        }, 1000),
        filterData: _.debounce(function() {
            this.fetchData()
            this.searchData.loading = false
        }, 800),
        search(data) {
            if (!this.$data['search_' + data]) {
                this.$data['all_' + data] = this.$data['all_' + data + '_copy'];
            }
            this.$data['all_' + data] = this.$data['all_' + data + '_copy'].filter((item) => {
                return item.text.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1;
            })
        },
        exportData() {
            if (this.exportRoute !== '') {
                window.open(this.exportRoute + `/?q=${this.searchData.q}&sortBy=${this.searchData.sortBy}&orderBy=${this.searchData.orderBy}&brand=${this.brands}&country=${this.countries}&type=${this.searchData.type}`, "_blank");
            } else {
                this.$toast.open({
                    message: 'Error occurred, please reload the page and try again.',
                    type: "error",
                })
            }
        }
    },
    created() {
        this.fetchData()

        let brand = new URL(location.href).searchParams.get('brandid')
        if (brand) {
            this.brands = parseInt(brand)
        }
    },
    watch: {
        currentPage: function () {
            this.fetchData()
        },
        'searchData.q': function () {
            if (this.searchData.q == null) {
                this.searchData.q = ""
            }
            this.filterData()
        },
        'searchData.sortBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.orderBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.perPage': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.type': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'brands': function () {
            if (this.brands == null) {
                this.brands = ''
            }
            this.searchData.loading = true
            this.filterData()
        },
        'countries': function () {
            if (this.countries == null) {
                this.countries = ''
            }
            this.searchData.loading = true
            this.filterData()
        }
    },
    mounted() {
        this.fetchBrands()
        this.fetchCountries()

        this.$store.dispatch('loadUserCompanyTierInfo')
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
        min-height: fit-content;
    }

button:focus {
    outline:0;
}

.btn-info {
    border-radius: 5px 0px 0px 5px;
}

.info-data {
    border: 2px solid #fb7e42;
    border-radius: 5px;
    color: #fb7e42;
    font-size: 1.25rem;
    font-weight: bold;
}

.info-label {
    color: #fb7e42;
}

</style>